/* ==========================================================================================================
   SK customer-experience stage (7 Oct 2026); in the SK SECOND SANDBOX review package since 13 Oct 2026.
   Small behaviours for the changes styled in assets/sk-cx.css. Each part checks that its markup exists and does
   nothing otherwise, so pages without it are unaffected. Nothing here adds to the cart, sends a message or saves a
   setting; the only data sent is the cart page's own quantity change or removal that the visitor asks for, and the
   cart note the visitor typed (part I, 13 Oct 2026): the same data the page's links, button and note box already sent.
     A. WhatsApp: the header icons take the floating button's link (same number, same message), then the floating
        button is hidden.
     B. Currency: the converter's box (Doubly app) is moved into the header (large screens) or the menu (phones), and
        kept out of the theme's select restyling.
     C. Language: the selector lists Weglot's languages; each link opens the same page on that language's address
        (16 Oct 2026: on a theme preview, with the preview carried on). Left out of the 13 Oct review package while
        the Arabic site showed English; printed again since the first release (16 Oct 2026).
     D. Collection filter panel: close button, click outside and Escape close it; after a filter, sort or "Clear all"
        the top of the results (bar, chosen filters, first row) is brought back under the header.
     E. Product page: the sticky Add to Cart bar names the chosen size and colour and mirrors the price; it hides
        while the page's own button is on screen.
     F. Product page: a note under the sizes explains crossed-out sizes and offers help when one is chosen.
     G. Product page: the returns line switches to "final sale" for a reduced size or colour; the "Delivery and
        returns" link opens the existing panel.
     H. Collection pages (9 Oct 2026; search pages too until 13 Oct): while the "Filter & sort" bar is see-through,
        its label and count each take the colour that reads on what is behind them, as the see-through header does.
     I. Cart page (review fixes, 13 Oct 2026): minus, plus, Remove and "Update cart" change quantities through
        Shopify's /cart/change.js, one line at a time and named by the line's key, and show Shopify's message under a
        line when it refuses a quantity, instead of an empty error page (links) or keeping more pieces than the shop
        holds (button).
     J. "Added to cart" window (review fixes, 13 Oct 2026): "Continue Shopping" stays on the address being viewed
        instead of opening the live site's full address written in the theme's script.
     K. Trunk Shows (review fixes, second pass, 13 Oct 2026): the shows' "Book Your Appointment" buttons are shown
        where the page's registration window opens from them; the window is kept visible, takes the focus when a
        button opens it, and closes with Escape.
   ========================================================================================================== */
(function () {
  'use strict';

  var d = document;
  var w = window;
  var root = d.documentElement;

  function ready(fn) {
    if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function onMedia(mql, fn) {
    if (mql.addEventListener) mql.addEventListener('change', fn);
    else if (mql.addListener) mql.addListener(fn);
  }

  var largeScreen = w.matchMedia('(min-width: 1100px)');

  /* ---- A. WhatsApp ------------------------------------------------------------------------------------- */
  function dockWhatsApp() {
    var source = d.getElementById('whatsapp-chat-icon');
    var targets = d.querySelectorAll('[data-sk-wa-link]');
    if (!source || !targets.length) return;
    var href = source.getAttribute('href');
    if (!href) return;
    for (var i = 0; i < targets.length; i++) {
      targets[i].setAttribute('href', href);
      targets[i].removeAttribute('hidden');
    }
    root.classList.add('sk-wa-docked');
  }

  /* ---- B. Currency ------------------------------------------------------------------------------------- */
  function currencySlot() {
    return d.querySelector(largeScreen.matches ? '[data-sk-currency-slot="desktop"]' : '[data-sk-currency-slot="mobile"]');
  }

  /* The theme restyles every drop-down it finds when a product list refreshes (theme.js selectReplace, run again after
     each filter or sort). On the docked converter that drew a 263 px box over the header icons: the menu wrapped onto
     two lines and the WhatsApp icon could no longer be clicked (8 Oct 2026). "noreplace" is the theme's own way to
     leave a drop-down alone; a box that was already restyled is put back. */
  function keepCurrencyPlain(box) {
    var selects = box.querySelectorAll('select');
    for (var i = 0; i < selects.length; i++) {
      var select = selects[i];
      select.classList.add('noreplace');
      var wrapper = select.parentNode;
      if (wrapper && wrapper.classList && wrapper.classList.contains('pretty-select') && wrapper.parentNode) {
        wrapper.parentNode.insertBefore(select, wrapper);
        wrapper.parentNode.removeChild(wrapper);
        select.classList.remove('replaced');
      }
    }
  }

  function dockCurrency() {
    var slot = currencySlot();
    if (!slot) return false;
    var boxes = d.querySelectorAll('.doubly-wrapper');
    if (!boxes.length) return false;
    // The app may draw a new box after the product list refreshes: the newest goes first, older ones are hidden.
    var box = boxes[boxes.length - 1];
    keepCurrencyPlain(box);
    if (box.parentNode !== slot || slot.firstElementChild !== box) slot.insertBefore(box, slot.firstChild);
    root.classList.add('sk-currency-docked');
    return true;
  }

  function watchCurrency() {
    if (!d.querySelector('[data-sk-currency-slot]')) return;
    var observer = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType === 1 && (node.classList.contains('doubly-wrapper') || node.querySelector('.doubly-wrapper'))) {
            dockCurrency();
            return;
          }
        }
      }
    });
    observer.observe(d.body, { childList: true });
    // If the app redraws its drop-down inside a box already docked here, the new one is kept plain too. (The
    // observer's own unwrapping changes nothing on its second pass, so it does not loop.)
    Array.prototype.forEach.call(d.querySelectorAll('[data-sk-currency-slot]'), function (slot) {
      new MutationObserver(function () {
        keepCurrencyPlain(slot);
      }).observe(slot, { childList: true, subtree: true });
    });
    onMedia(largeScreen, dockCurrency);
    // The app draws its box after its own script loads; look again for a few seconds in case it is not added
    // directly to <body>.
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (dockCurrency() || tries > 20) clearInterval(timer);
    }, 500);
    dockCurrency();
  }

  /* The see-through header prototype (sections/sk-page-mode.liquid, local only) colours each header part for what is
     behind it; the language and currency group takes the colour of the search icon beside it. */
  function followHeaderTone() {
    var group = d.querySelector('.nav-right-side > .sk-locale--desktop');
    var source = d.querySelector('.nav-right-side > a.nav-search') || d.querySelector('.nav-right-side > a');
    if (!group || !source || !d.body.classList.contains('sk-clear-header')) return;
    function copy() {
      var tone = source.getAttribute('data-sk-tone');
      if (tone) group.setAttribute('data-sk-tone', tone);
      else group.removeAttribute('data-sk-tone');
    }
    new MutationObserver(copy).observe(source, { attributes: true, attributeFilter: ['data-sk-tone'] });
    copy();
  }

  /* ---- C. Language --------------------------------------------------------------------------------------- */
  // Names in their own language, with Weglot's codes (Weglot's public language list, 7 Oct 2026); any other code
  // falls back to Weglot's own name for it, or the code.
  var LANGUAGE_NAMES = {
    en: 'English', ar: 'العربية', fr: 'Français', 'fr-ca': 'Français (Canada)', es: 'Español',
    'es-419': 'Español Latinoamericano', it: 'Italiano', de: 'Deutsch', ru: 'Русский', zh: '中文 (简体)',
    'zh-tw': '中文 (繁體)', ja: '日本語', ko: '한국어', tr: 'Türkçe', pt: 'Português', 'pt-br': 'Português Brasileiro',
    nl: 'Nederlands', hi: 'हिंदी', fa: 'فارسی', he: 'עברית', ur: 'اردو', el: 'Ελληνικά', pl: 'Polski', sv: 'Svenska',
    da: 'Dansk', id: 'Bahasa Indonesia', ms: 'Bahasa Melayu', th: 'ภาษาไทย', vi: 'Tiếng Việt', uk: 'Українська',
    az: 'Azərbaycan dili', kk: 'Қазақша', hy: 'հայերեն', ka: 'ქართული', ro: 'Română', cs: 'Čeština', hu: 'Magyar'
  };
  // Right-to-left languages in Weglot's list.
  var RIGHT_TO_LEFT = { ar: true, fa: true, he: true, ku: true, ps: true, ur: true, ug: true, kb: true, dv: true };

  function whenWeglot(callback) {
    var waited = 0;
    (function check() {
      var wg = w.Weglot;
      if (wg && wg.initialized && wg.options && wg.options.language_from) {
        callback(wg);
        return;
      }
      waited += 250;
      if (waited <= 15000) setTimeout(check, 250);
    })();
  }

  // The page being viewed, without preview-only parameters, so the other language opens the same page (filters and
  // the chosen size included).
  function currentPath() {
    var search = w.location.search.replace(/^\?/, '').split('&').filter(function (pair) {
      return pair && !/^(preview_theme_id|_ab|_fd|_sc|pb)=/.test(pair);
    }).join('&');
    return w.location.pathname + (search ? '?' + search : '') + w.location.hash;
  }

  // 16 Oct 2026: on a theme preview (a theme that is not the published one, opened with ?preview_theme_id=, such as
  // SK SECOND SANDBOX before publication), the other language's link carries the preview on, so the same theme shows
  // there too (Weglot passes the parameter to the store: checked on ar.saiidkobeisy.com). On the published theme
  // nothing is added.
  function previewParameter() {
    var theme = w.Shopify && w.Shopify.theme;
    if (!theme || !theme.id || theme.role === 'main') return '';
    return 'preview_theme_id=' + encodeURIComponent(theme.id);
  }

  // The page being viewed, on another language's address.
  function addressOn(host) {
    var path = currentPath();
    var preview = previewParameter();
    if (preview) {
      var hashAt = path.indexOf('#');
      var hash = hashAt < 0 ? '' : path.slice(hashAt);
      var rest = hashAt < 0 ? path : path.slice(0, hashAt);
      path = rest + (rest.indexOf('?') < 0 ? '?' : '&') + preview + hash;
    }
    return 'https://' + host + path;
  }

  function attribute(value) {
    return String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  // Host of an absolute link (https://host/...), or null for a link to this page.
  function hostOf(href) {
    var match = /^https?:\/\/([^\/?#]+)/i.exec(href || '');
    return match ? match[1] : null;
  }

  // Each language's address as written by snippets/sk-language-selector.liquid (before Weglot rebuilds the list).
  function knownHosts(selector) {
    var hosts = {};
    var links = selector.querySelectorAll('[data-sk-lang-code]');
    for (var i = 0; i < links.length; i++) {
      var host = hostOf(links[i].getAttribute('href'));
      if (host) hosts[links[i].getAttribute('data-sk-lang-code')] = host;
    }
    return hosts;
  }

  // The language shown: Weglot's own answer once it runs; before that, the language whose address this is (Arabic on
  // ar.saiidkobeisy.com); anywhere else (the store's own address, the local preview) the original language.
  function shownLanguage(selector) {
    var wg = w.Weglot;
    if (wg && wg.initialized && wg.getCurrentLang && wg.getCurrentLang()) return wg.getCurrentLang();
    var hosts = selector.skLangHosts || knownHosts(selector);
    for (var code in hosts) {
      if (Object.prototype.hasOwnProperty.call(hosts, code) && hosts[code] === w.location.host) return code;
    }
    return (wg && wg.options && wg.options.language_from) || 'en';
  }

  function languageHref(code, options, current, hosts) {
    if (code === current) return currentPath();
    if (code === options.language_from) return addressOn(options.host || hosts[code] || w.location.host);
    var languages = options.languages || [];
    for (var i = 0; i < languages.length; i++) {
      var language = languages[i];
      if (language.language_to === code && language.connect_host_destination && language.connect_host_destination.host) {
        return addressOn(language.connect_host_destination.host);
      }
    }
    return hosts[code] ? addressOn(hosts[code]) : null;
  }

  // Brings a link's address up to date with the page (filters chosen after the page loaded), for clicks, middle-clicks,
  // keyboard and "open in new tab".
  function refreshLanguageLink(link) {
    var href = link.getAttribute('href') || '';
    var host = hostOf(href);
    if (host) link.setAttribute('href', addressOn(host));
    else if (href.charAt(0) === '/') link.setAttribute('href', currentPath());
  }

  function renderLanguages(selector, codes, current, options) {
    var list = selector.querySelector('[data-sk-lang-list]');
    if (!list) return;
    var hosts = selector.skLangHosts || knownHosts(selector);
    var html = '';
    for (var i = 0; i < codes.length; i++) {
      var code = codes[i];
      var href = languageHref(code, options, current, hosts);
      if (!href) continue;
      var name = LANGUAGE_NAMES[code] || (w.Weglot.getLanguageName ? w.Weglot.getLanguageName(code) : code);
      html += '<li><a class="sk-lang__link" href="' + attribute(href) + '" hreflang="' + attribute(code) + '" lang="' +
        attribute(code) + '"' + (RIGHT_TO_LEFT[code] ? ' dir="rtl"' : '') + ' data-sk-lang-code="' + attribute(code) +
        '"' + (code === current ? ' aria-current="true"' : '') + '>' + attribute(name) + '</a></li>';
    }
    if (html) list.innerHTML = html;
    var label = selector.querySelector('[data-sk-lang-current]');
    if (label) label.textContent = LANGUAGE_NAMES[current] || current;
  }

  function initLanguages() {
    var selectors = d.querySelectorAll('[data-sk-lang]');
    if (!selectors.length) return;

    Array.prototype.forEach.call(selectors, function (selector) {
      var toggle = selector.querySelector('[data-sk-lang-toggle]');
      var list = selector.querySelector('[data-sk-lang-list]');
      selector.skLangHosts = knownHosts(selector);
      // Mark the language shown before Weglot runs (the snippet always marks English).
      var shown = shownLanguage(selector);
      Array.prototype.forEach.call(selector.querySelectorAll('[data-sk-lang-code]'), function (link) {
        if (link.getAttribute('data-sk-lang-code') === shown) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
      var shownLabel = selector.querySelector('[data-sk-lang-current]');
      if (shownLabel && LANGUAGE_NAMES[shown]) shownLabel.textContent = LANGUAGE_NAMES[shown];
      function close() {
        if (!toggle || !list) return;
        list.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
      }
      if (toggle && list) {
        toggle.addEventListener('click', function (event) {
          event.preventDefault();
          var opening = list.hasAttribute('hidden');
          if (opening) list.removeAttribute('hidden');
          else list.setAttribute('hidden', '');
          toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
        });
        d.addEventListener('click', function (event) {
          if (!selector.contains(event.target)) close();
        });
        selector.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') {
            close();
            toggle.focus();
          }
        });
      }
      // Each language lives on its own address (Weglot's subdomains: Arabic on ar.saiidkobeisy.com), so a link opens
      // the same page there. The links are followed, not handed to Weglot.switchTo: on the local preview that call
      // only changed Weglot's internal language and nothing happened on screen (found 8 Oct 2026). The language
      // already shown just closes the list. Addresses are brought up to date when a link is pointed at, focused or
      // clicked, so filters chosen after the page loaded are kept. (If Weglot's URL translation is switched on later,
      // translated page addresses differ between languages: check these links on the store's addresses then.)
      function refreshFrom(event) {
        var link = event.target.closest ? event.target.closest('[data-sk-lang-code]') : null;
        if (link) refreshLanguageLink(link);
      }
      selector.addEventListener('pointerdown', refreshFrom);
      selector.addEventListener('mouseover', refreshFrom);
      selector.addEventListener('focusin', refreshFrom);
      selector.addEventListener('click', function (event) {
        var link = event.target.closest ? event.target.closest('[data-sk-lang-code]') : null;
        if (!link) return;
        if (link.getAttribute('data-sk-lang-code') === shownLanguage(selector)) {
          event.preventDefault();
          close();
          return;
        }
        refreshLanguageLink(link);
      });
    });

    // Languages switched on later in Weglot appear here without a theme change.
    whenWeglot(function (wg) {
      var options = wg.options;
      var codes = [options.language_from];
      (options.languages || []).forEach(function (language) {
        if (language && language.enabled !== false && language.language_to && codes.indexOf(language.language_to) < 0) {
          codes.push(language.language_to);
        }
      });
      var current = (wg.getCurrentLang && wg.getCurrentLang()) || options.language_from;
      Array.prototype.forEach.call(selectors, function (selector) {
        renderLanguages(selector, codes, current, options);
      });
    });
  }

  /* ---- D. Collection filter panel ---------------------------------------------------------------------- */
  function filterPanelOpen() {
    var panel = d.querySelector('.cc-product-filter');
    return panel && panel.classList.contains('-in');
  }

  function closeFilterPanel() {
    var button = d.querySelector('[data-show-filter]');
    if (!button || !filterPanelOpen()) return;
    button.click();
    // back to the "Filter & sort" button, so keyboard users continue from where they opened the panel
    try {
      button.focus({ preventScroll: true });
    } catch (error) {
      button.focus();
    }
  }

  function initFilterPanel() {
    d.addEventListener('click', function (event) {
      var closer = event.target.closest ? event.target.closest('[data-sk-filter-close]') : null;
      if (!closer) return;
      event.preventDefault();
      closeFilterPanel();
    });
    d.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && filterPanelOpen()) closeFilterPanel();
    });
  }

  /* After a filter, sort, chip or "Clear all", the theme replaces the results in place and scrolls to them only when
     the page was more than 200 px past their top. Between the top and 200 px the page stayed where it was, so the
     row of chosen filters (with "Clear all") and the first products were hidden above the screen, behind the header
     and the filter bar (found 8 Oct 2026). The top of the results is now brought back under the header. When the
     theme is already scrolling there, its scroll is kept, except on a page with a short title (see below). */
  function revealResultsTop() {
    var results = d.querySelector('[data-ajax-scroll-to]');
    if (!results) return;
    var header = parseFloat(w.getComputedStyle(root).getPropertyValue('--nav-height')) || 0;
    var top = results.getBoundingClientRect().top;
    var offset = (w.pageYOffset || d.documentElement.scrollTop) + top;
    // Results that start in the upper half of the first screen (a short page title): back to the top of the page, so
    // the title is not left half under the see-through header.
    var shortTitle = offset <= w.innerHeight / 2;
    var jq = (w.theme && w.theme.jQuery) || w.jQuery;
    if (jq && jq('html, body').is(':animated')) {
      // The theme is already scrolling to the results (the page was more than 200 px past them). It stops 25 px above
      // their top, which left a short page title under the see-through header ("SHOP" behind the logo on a phone,
      // found 13 Oct 2026). For such a page it now goes back to the top instead; otherwise the theme's scroll stays.
      if (!shortTitle) return;
      jq('html, body').stop(true);
    } else if (top >= header - 1) {
      return;
    }
    var target = shortTitle ? 0 : Math.max(0, offset - header);
    try {
      w.scrollTo({ top: target, behavior: 'smooth' });
    } catch (error) {
      w.scrollTo(0, target);
    }
  }

  function watchFilterResults() {
    var results = d.querySelector('[data-ajax-scroll-to]');
    if (!results || !('MutationObserver' in w)) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      // after the theme's own update has finished (it starts its scroll in the same step)
      setTimeout(function () {
        queued = false;
        revealResultsTop();
      }, 0);
    }).observe(results, { childList: true });
  }

  /* ---- H. Filter bar: see-through like the header -------------------------------------------------------- */
  // On screens with a mouse the "Filter & sort" bar has no background until it is hovered, focused from the keyboard
  // or its panel is open (assets/sk-cx.css, section 1). Meanwhile its label (with the icon) and its count each take
  // the colour that reads on what is behind them: data-sk-tone="dark" (white text) over a dark photo, no value or
  // "light" (dark text) over the white page or a light photo. They are measured the way the see-through header is
  // (assets/sk-page-mode.js): each photo is read once, squashed to 24 x 32 cells, the cells under the text are
  // averaged, and the colour only changes past a margin, so it does not flicker on mid-tones. A photo still being
  // read leaves the colour as it was. Touch screens keep the white bar, so nothing is measured there.
  var TONE_W = 24;
  var TONE_H = 32;
  var toneCells = {};

  function luminance(r, g, b) {
    return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
  }

  function parseRgb(value) {
    var m = value && value.match(/rgba?\(([^)]+)\)/);
    if (!m) return null;
    var p = m[1].split(/[\s,\/]+/).filter(Boolean).map(parseFloat);
    return { r: p[0], g: p[1], b: p[2], a: p.length > 3 ? p[3] : 1 };
  }

  // pictures shown on hover sit on top at opacity 0: those are not what the visitor sees
  function seen(el) {
    var opacity = 1;
    for (var n = 0; el && el !== d.body && n < 6; n++) {
      opacity *= parseFloat(w.getComputedStyle(el).opacity) || 0;
      if (opacity < 0.35) return false;
      el = el.parentElement;
    }
    return true;
  }

  function photoCells(src, done) {
    var cached = toneCells[src];
    if (cached) return cached;
    toneCells[src] = 'wait';
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var canvas = d.createElement('canvas');
        canvas.width = TONE_W;
        canvas.height = TONE_H;
        var ctx = canvas.getContext('2d');
        // see-through parts of a picture (a cut-out PNG) sit on the white page, not on black
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, TONE_W, TONE_H);
        ctx.drawImage(img, 0, 0, TONE_W, TONE_H);
        var data = ctx.getImageData(0, 0, TONE_W, TONE_H).data;
        var cells = new Float32Array(TONE_W * TONE_H);
        for (var i = 0; i < cells.length; i++) cells[i] = luminance(data[i * 4], data[i * 4 + 1], data[i * 4 + 2]);
        toneCells[src] = cells;
      } catch (error) {
        toneCells[src] = 'fail';
      }
      done();
    };
    img.onerror = function () {
      toneCells[src] = 'fail';
      done();
    };
    img.src = src;
    return 'wait';
  }

  // brightness of a photo at a screen point: a number, null outside the picture, undefined while it is being read
  function photoBrightness(img, x, y, done) {
    var src = img.currentSrc || img.src;
    var nw = img.naturalWidth;
    var nh = img.naturalHeight;
    if (!src || !nw || !nh) return undefined;
    var r = img.getBoundingClientRect();
    var fit = w.getComputedStyle(img).objectFit;
    var dw = r.width;
    var dh = r.height;
    if (fit === 'contain' || fit === 'cover') {
      var scale = fit === 'contain' ? Math.min(r.width / nw, r.height / nh) : Math.max(r.width / nw, r.height / nh);
      dw = nw * scale;
      dh = nh * scale;
    }
    var u = (x - (r.left + (r.width - dw) / 2)) / dw;
    var v = (y - (r.top + (r.height - dh) / 2)) / dh;
    if (u < 0 || u > 1 || v < 0 || v > 1) return null;
    var cells = photoCells(src, done);
    if (cells === 'wait') return undefined;
    // a photo that cannot be read: dark text with its white outline is the safer guess (it stays legible on a dark
    // photo; white text with its lighter dark outline would not on a light one)
    if (cells === 'fail') return 0.7;
    var gx = Math.min(TONE_W - 1, Math.floor(u * TONE_W));
    var gy = Math.min(TONE_H - 1, Math.floor(v * TONE_H));
    var sum = 0;
    var count = 0;
    for (var j = -1; j <= 1; j++) {
      for (var i = -2; i <= 2; i++) {
        var cx = gx + i;
        var cy = gy + j;
        if (cx < 0 || cy < 0 || cx >= TONE_W || cy >= TONE_H) continue;
        sum += cells[cy * TONE_W + cx];
        count++;
      }
    }
    return count ? sum / count : null;
  }

  // While a product is hovered, its first photo fades out and the second one shows; the second photo ignores the
  // pointer, so it is not among the elements under a point and is looked up here.
  function shownTwin(img, x, y) {
    var box = img.closest('.image, .product-block');
    if (!box) return null;
    var others = box.querySelectorAll('img');
    for (var i = 0; i < others.length; i++) {
      var other = others[i];
      if (other === img || !seen(other)) continue;
      var r = other.getBoundingClientRect();
      if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) return other;
    }
    return null;
  }

  // brightness of what the page shows under a point of the bar (the bar itself is looked through)
  function brightnessUnder(bar, x, y, done) {
    var stack = d.elementsFromPoint(x, y);
    for (var k = 0; k < stack.length; k++) {
      var el = stack[k];
      if (el === root || el === d.body) break;
      if (bar.contains(el)) continue;
      var tag = el.tagName;
      if (tag === 'IMG') {
        var img = seen(el) ? el : shownTwin(el, x, y);
        if (!img) continue;
        var b = photoBrightness(img, x, y, done);
        if (b === null) continue;
        return b;
      }
      if (!seen(el)) continue;
      if (tag === 'VIDEO' || tag === 'CANVAS' || tag === 'IFRAME') return 0.7; // unknown: the safer dark text
      var style = w.getComputedStyle(el);
      var bg = parseRgb(style.backgroundColor);
      if (bg && bg.a > 0.6) return luminance(bg.r, bg.g, bg.b);
      if (style.backgroundImage && style.backgroundImage.indexOf('url(') > -1) return 0.7;
    }
    var page = parseRgb(w.getComputedStyle(d.body).backgroundColor);
    return page && page.a > 0.1 ? luminance(page.r, page.g, page.b) : 1;
  }

  function initFilterBarTone() {
    if (!d.elementsFromPoint || !w.matchMedia || !w.requestAnimationFrame) return;
    if (!d.querySelector('.sk-filter-bar')) return;
    // 13 Oct 2026: the bar is see-through only under the see-through header (collection pages, body.sk-clear-header,
    // assets/sk-cx.css section 1); elsewhere it stays white, so there is nothing to measure.
    if (!d.body.classList.contains('sk-clear-header')) return;
    var mouse = w.matchMedia('(hover: hover)');
    var queued = false;
    var dirty = true;
    var lastY = -1;
    var lastRun = 0;

    function update(now) {
      queued = false;
      if (!mouse.matches) return;
      if (!dirty && w.pageYOffset === lastY) return;
      // at most about 15 checks a second while scrolling, like the header; the last one always runs
      if (now - lastRun < 66) {
        queued = true;
        setTimeout(function () {
          w.requestAnimationFrame(update);
        }, 66 - (now - lastRun));
        return;
      }
      lastRun = now;
      dirty = false;
      lastY = w.pageYOffset;
      var parts = d.querySelectorAll('.sk-filter-bar:not(.active) .sk-filter-bar__toggle, .sk-filter-bar:not(.active) .sk-filter-bar__count');
      for (var p = 0; p < parts.length; p++) {
        var part = parts[p];
        var bar = part.closest('.sk-filter-bar');
        var r = part.getBoundingClientRect();
        if (r.width < 2 || r.height < 2 || r.bottom < 0 || r.top > w.innerHeight) continue;
        var y = Math.max(1, Math.min(w.innerHeight - 1, r.top + r.height / 2));
        var sum = 0;
        var count = 0;
        for (var i = 0; i < 3; i++) {
          var x = r.left + r.width * (0.1 + 0.4 * i);
          if (x < 0 || x > w.innerWidth) continue;
          var b = brightnessUnder(bar, x, y, invalidate);
          if (b === undefined) continue;
          sum += b;
          count++;
        }
        if (!count) continue;
        var lum = sum / count;
        var was = part.getAttribute('data-sk-tone');
        var tone = was === 'dark' ? (lum > 0.56 ? 'light' : 'dark') : (lum < 0.46 ? 'dark' : 'light');
        if (tone !== was) part.setAttribute('data-sk-tone', tone);
      }
    }

    function invalidate() {
      dirty = true;
      if (!queued) {
        queued = true;
        w.requestAnimationFrame(update);
      }
    }

    w.addEventListener('scroll', invalidate, { passive: true });
    w.addEventListener('resize', invalidate, { passive: true });
    w.addEventListener('load', invalidate);
    // photos arriving or fading in, the panel closing, and new results after a filter, sort or "load more" (the
    // theme redraws the bar and the products in place)
    d.addEventListener('load', function (event) {
      if (event.target && event.target.tagName === 'IMG') invalidate();
    }, true);
    d.addEventListener('transitionend', invalidate, true);
    var section = d.querySelector('.sk-filter-bar').closest('[data-section-type]') || d.body;
    if ('MutationObserver' in w) {
      new MutationObserver(invalidate).observe(section, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
    if (mouse.addEventListener) mouse.addEventListener('change', invalidate);
    else if (mouse.addListener) mouse.addListener(invalidate);
    var checks = 0;
    var timer = setInterval(function () {
      invalidate();
      if (++checks > 12) clearInterval(timer);
    }, 500);
    invalidate();
  }

  /* ---- E, F, G. Product page --------------------------------------------------------------------------- */
  var SIZE_NAME = /^(size|taille|talla|taglia|größe|groesse|maat|المقاس|مقاس)$/i;
  var COLOUR_NAME = /^(colou?r|couleur|color|farbe|kleur|اللون)$/i;

  function optionIndex(product, pattern) {
    var options = (product && product.options) || [];
    for (var i = 0; i < options.length; i++) {
      var name = typeof options[i] === 'string' ? options[i] : options[i].name;
      if (pattern.test(String(name).trim())) return i;
    }
    return -1;
  }

  function variantLabel(variant, product) {
    if (!variant || !product || !variant.options || (product.variants && product.variants.length < 2)) return '';
    var parts = [];
    var sizeAt = optionIndex(product, SIZE_NAME);
    for (var i = 0; i < variant.options.length; i++) {
      var value = variant.options[i];
      if (!value || value === 'Default Title') continue;
      parts.push(i === sizeAt ? 'Size ' + value : value);
    }
    return parts.join(' · ');
  }

  function productData(area) {
    var script = area.querySelector('[data-product-json]') || d.querySelector('#cc-product-json-' + area.getAttribute('data-product-id'));
    if (script) {
      try { return JSON.parse(script.textContent); } catch (error) { /* fall through */ }
    }
    return null;
  }

  function whatsappBase() {
    var link = d.getElementById('whatsapp-chat-icon') || d.querySelector('a[href*="wa.me/"]');
    if (!link) return null;
    var href = link.getAttribute('href') || '';
    return href.split('?')[0];
  }

  function enquiryHref(title, size, colour, sku) {
    var base = whatsappBase();
    if (!base) return null;
    var canonical = d.querySelector('link[rel="canonical"]');
    var page = canonical ? canonical.href : w.location.origin + w.location.pathname;
    var line = 'Hello, I’m interested in ' + title + ', size ' + size + (colour ? ' (' + colour + ')' : '') + '.';
    var text = line + '\n' + page + (sku ? '\nRef. ' + sku : '');
    return base + '?text=' + encodeURIComponent(text);
  }

  function initProductPage() {
    var area = d.querySelector('.product-area[data-section-type="product-template"]');
    if (!area) return;
    var productId = area.getAttribute('data-product-id');
    var product = productData(area);

    /* E. sticky bar */
    var bar = area.querySelector('[data-sk-sticky-atc]');
    var barLabel = bar ? bar.querySelector('[data-sk-sticky-variant]') : null;
    var barPrice = bar ? bar.querySelector('[data-sk-sticky-price]') : null;
    var priceArea = area.querySelector('.price-area');

    function copyPrice() {
      if (!barPrice || !priceArea) return;
      var shown = priceArea.querySelector('.price');
      var text = shown ? shown.textContent.replace(/\s+/g, ' ').trim() : '';
      if (text && barPrice.textContent !== text) barPrice.textContent = text;
    }

    if (bar) {
      if (priceArea) {
        new MutationObserver(copyPrice).observe(priceArea, { childList: true, characterData: true, subtree: true });
        copyPrice();
      } else if (barPrice) {
        barPrice.hidden = true;
      }
      var mainButton = area.querySelector('.product-purchase-form [type="submit"]');
      if (mainButton && 'IntersectionObserver' in w) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            bar.classList.toggle('sk-sticky-atc--hidden', entry.isIntersecting);
          });
        }, { threshold: 0.25 }).observe(mainButton);
      }
    }

    /* F. size note */
    var sizeWrapper = null;
    var wrappers = area.querySelectorAll('.option-selectors .selector-wrapper[data-option-name]');
    for (var i = 0; i < wrappers.length; i++) {
      if (SIZE_NAME.test(wrappers[i].getAttribute('data-option-name').trim())) {
        sizeWrapper = wrappers[i];
        break;
      }
    }
    var note = null;
    if (sizeWrapper) {
      note = d.createElement('p');
      note.className = 'sk-size-note';
      note.setAttribute('aria-live', 'polite');
      note.hidden = true;
      sizeWrapper.appendChild(note);
    }

    function selectedColour() {
      for (var k = 0; k < wrappers.length; k++) {
        if (COLOUR_NAME.test(wrappers[k].getAttribute('data-option-name').trim())) {
          var label = wrappers[k].querySelector('.cc-swatches__label');
          if (label && label.textContent.trim()) return label.textContent.trim();
          var select = wrappers[k].querySelector('select');
          if (select) return select.value;
        }
      }
      return '';
    }

    function refreshSizeNote(variant) {
      if (!note) return;
      var boxes = sizeWrapper.querySelectorAll('.clickyboxes li a');
      if (!boxes.length) {
        note.hidden = true;
        return;
      }
      var unavailable = 0;
      var chosen = null;
      for (var b = 0; b < boxes.length; b++) {
        if (boxes[b].classList.contains('unavailable')) unavailable += 1;
        if (boxes[b].classList.contains('active')) chosen = boxes[b];
      }
      var colour = selectedColour();
      var chosenUnavailable = (chosen && chosen.classList.contains('unavailable')) || (variant && variant.available === false);
      if (chosenUnavailable && chosen) {
        var size = chosen.textContent.trim();
        var titleNode = area.querySelector('.product-area__details__title');
        var title = titleNode ? titleNode.textContent.replace(/\s+/g, ' ').trim() : d.title;
        var href = enquiryHref(title, size, colour, variant && variant.sku);
        note.className = 'sk-size-note sk-size-note--selected';
        note.innerHTML = '';
        note.appendChild(d.createTextNode('Size ' + size + ' is currently unavailable' + (colour ? ' in ' + colour : '') + '. '));
        if (href) {
          var ask = d.createElement('a');
          ask.href = href;
          ask.target = '_blank';
          ask.rel = 'noopener';
          ask.textContent = 'Ask our advisors about this size';
          note.appendChild(ask);
        }
        note.hidden = false;
      } else if (unavailable > 0) {
        note.className = 'sk-size-note';
        note.textContent = 'Crossed-out sizes are currently unavailable' + (colour ? ' in ' + colour : '') + '.';
        note.hidden = false;
      } else {
        note.hidden = true;
      }
    }

    /* G. returns line and the details link */
    var returnsLine = area.querySelector('[data-sk-assure-returns]');
    var finalSaleLine = area.querySelector('[data-sk-assure-final-sale]');

    function refreshReturns(variant) {
      if (!variant || !returnsLine || !finalSaleLine) return;
      var reduced = variant.compare_at_price && variant.compare_at_price > variant.price;
      returnsLine.hidden = !!reduced;
      finalSaleLine.hidden = !reduced;
    }

    d.addEventListener('click', function (event) {
      var opener = event.target.closest ? event.target.closest('[data-sk-open-delivery]') : null;
      if (!opener) return;
      var titles = area.querySelectorAll('.product-detail-accordion .cc-accordion-item__title');
      for (var t = 0; t < titles.length; t++) {
        if (/delivery|return/i.test(titles[t].textContent)) {
          event.preventDefault();
          var item = titles[t].closest('details');
          if (item && !item.open) titles[t].click();
          titles[t].scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
      }
      // no panel on this page: the link's own address (the delivery policy) opens
    });

    function update(variant, data) {
      if (barLabel && variant) barLabel.textContent = variantLabel(variant, data || product);
      refreshReturns(variant);
      setTimeout(function () {
        refreshSizeNote(variant);
        copyPrice();
      }, 60);
    }

    if (w.jQuery) {
      w.jQuery(w).on('cc-variant-updated', function (event, data) {
        if (!data || !data.variant) return;
        if (data.product && productId && String(data.product.id) !== String(productId)) return;
        update(data.variant, data.product);
      });
    }

    // First state, before any choice: the variant in the form.
    var initialVariant = null;
    var idInput = area.querySelector('.product-purchase-form select[name="id"], .product-purchase-form [name="id"]');
    if (product && idInput) {
      for (var v = 0; v < product.variants.length; v++) {
        if (String(product.variants[v].id) === String(idInput.value)) initialVariant = product.variants[v];
      }
    }
    setTimeout(function () {
      refreshSizeNote(initialVariant);
    }, 400);
  }

  /* ---- I. Cart page: quantities -------------------------------------------------------------------------- */
  // Review fixes (13 Oct 2026). Before: the minus, plus and Remove links each opened /cart/change with the new
  // quantity, and when Shopify refused it (more pieces than the shop holds) that address answered with an empty
  // error page. "Update cart" (also used by Enter in a quantity field) posted every quantity to /cart, which keeps
  // quantities the shop cannot supply until checkout refuses them. Now each change goes through /cart/change.js,
  // one line at a time, then the page is loaded again with what the cart really holds. Second pass (same day): each
  // line is named by its line key (data-sk-key, printed by sections/main-cart.liquid), not by its position, so a
  // removal cannot make a later change land on another piece.
  // When Shopify refuses a quantity, its own message is shown under that line after the reload (carried in this
  // tab's sessionStorage), linked to the line's quantity field for screen readers, and it gets the focus; if that
  // line has gone, the message is shown above the cart. A typed value that is not a whole number is not sent. If the
  // cart cannot be reached before anything has changed, the link or the button works as before; if it fails after a
  // change was made, the page is loaded again with a message instead (the theme's form matches quantities to lines by
  // position, which may no longer fit). "Check out" is left to the browser, except that it is held back while a
  // change is being sent (the page loads again a moment later). Besides the quantities, the cart note the visitor
  // typed is saved before the page is loaded again (the theme saves it the same way, half a second after typing).
  // sections/main-cart.liquid leaves out the plus at the stock limit and prints the note that this part fills.
  function initCartQuantities() {
    var storeKey = 'skCartQuantityNotes';
    var refused = 'This quantity is not available.';
    var partial = 'Some changes could not be saved. Please check the quantities and try again.';
    var busy = false;
    var leaving = false;

    // Messages carried across the reload are read (and cleared) first, so that none is left behind when the page
    // has no cart form (an empty cart).
    var carried = null;
    try {
      var saved = w.sessionStorage.getItem(storeKey);
      if (saved) {
        w.sessionStorage.removeItem(storeKey);
        carried = JSON.parse(saved);
      }
    } catch (e) {
      carried = null; // no storage in this tab, or nothing readable: nothing to show
    }

    var form = d.getElementById('cartform');

    function quantityFields() {
      return form ? form.querySelectorAll('input[name="updates[]"]') : [];
    }

    function lineOf(field) {
      var fields = quantityFields();
      for (var i = 0; i < fields.length; i++) {
        if (fields[i] === field) return i + 1;
      }
      return 0;
    }

    function fieldForKey(key) {
      var fields = quantityFields();
      for (var i = 0; i < fields.length; i++) {
        if (fields[i].getAttribute('data-sk-key') === key) return fields[i];
      }
      return null;
    }

    // The note under a line: the one printed by the theme (stock limit) or a new one. It describes the line's
    // quantity field, so a screen reader reads it with the field. "live": shown without a reload, read out at once.
    function showNote(field, message, live) {
      var holder = (field.closest && field.closest('.quantity-and-remove')) || field.parentNode;
      var note = holder.querySelector('[data-sk-qty-note]');
      if (!note) {
        note = d.createElement('p');
        note.className = 'sk-cart-qty-note';
        note.setAttribute('data-sk-qty-note', '');
        holder.appendChild(note);
      }
      if (!note.id) note.id = 'sk-qty-note-' + lineOf(field);
      note.setAttribute('tabindex', '-1');
      note.classList.add('sk-cart-qty-note--alert');
      if (live) note.setAttribute('role', 'alert');
      note.textContent = message;
      field.setAttribute('aria-describedby', note.id);
      return note;
    }

    // A message that belongs to no line on the page: above the cart, or under the title of the empty cart.
    function showPageNote(message) {
      var section = d.querySelector('[data-section-type="cart-template"]');
      if (!section) return null;
      var note = section.querySelector('[data-sk-cart-page-note]');
      if (!note) {
        note = d.createElement('p');
        note.className = 'sk-cart-qty-note sk-cart-qty-note--alert sk-cart-page-note';
        note.setAttribute('data-sk-cart-page-note', '');
        note.setAttribute('tabindex', '-1');
        var title = section.querySelector('h1');
        if (form && form.parentNode === section) section.insertBefore(note, form);
        else if (title && title.parentNode === section) section.insertBefore(note, title.nextSibling);
        else section.insertBefore(note, section.firstChild);
      }
      note.textContent = message;
      return note;
    }

    // Messages from before the reload: under their lines, or above the cart when the line has gone. The first one
    // gets the focus, so that it is read out and in view.
    function showCarried(notes) {
      if (!notes || typeof notes !== 'object') return;
      var lines = notes.lines && typeof notes.lines === 'object' ? notes.lines : {};
      var pageMessages = [];
      if (notes.page) pageMessages.push(String(notes.page));
      var shown = [];
      Object.keys(lines).forEach(function (key) {
        var message = String(lines[key]);
        var field = fieldForKey(key);
        if (field) shown.push(showNote(field, message, false));
        else if (pageMessages.indexOf(message) < 0) pageMessages.push(message);
      });
      var first = pageMessages.length ? showPageNote(pageMessages.join(' ')) : null;
      if (!first && shown.length) {
        shown.sort(function (a, b) {
          return a.compareDocumentPosition(b) & 4 ? -1 : 1; // 4: b comes after a
        });
        first = shown[0];
      }
      if (first && first.focus) first.focus();
    }

    showCarried(carried);
    if (!form || !w.fetch || !w.JSON || !w.Promise) return;

    var cartUrl = (w.theme && w.theme.routes && w.theme.routes.cart_url) || '/cart';

    function setBusy(state) {
      busy = state;
      if (state) form.setAttribute('aria-busy', 'true');
      else form.removeAttribute('aria-busy');
    }
    // A cart page brought back by the browser's Back button (from its page cache) must not stay busy, nor keep the
    // marks of a form sent the theme's way.
    w.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      setBusy(false);
      leaving = false;
      form.removeAttribute('data-sk-native-submit');
      var flags = form.querySelectorAll('input[data-sk-update-flag]');
      for (var i = 0; i < flags.length; i++) flags[i].parentNode.removeChild(flags[i]);
    });

    // Shopify's answer: { ok: true }, or { ok: false, message } when it refuses the quantity (422). Anything else
    // (network failure, other status) rejects. target: { id: line key } or, without a key, { line: position }.
    function changeLine(target, quantity) {
      var body = { quantity: quantity };
      if (target.id) body.id = target.id;
      else body.line = target.line;
      return w.fetch(cartUrl + '/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (response) {
        return response.json().then(null, function () {
          return {};
        }).then(function (data) {
          if (response.ok) return { ok: true };
          if (response.status === 422) {
            return { ok: false, message: (data && (data.description || data.message)) || refused };
          }
          throw new Error('cart answered ' + response.status);
        });
      });
    }

    // The cart note can still be waiting in the theme's half-second timer: save it before the page is loaded again.
    function saveCartNote() {
      var note = form.querySelector('[name="note"]');
      if (!note || note.value === note.defaultValue) return Promise.resolve();
      return w.fetch(cartUrl + '/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: note.value })
      }).then(function () {}, function () {});
    }

    function addMessage(notes, key, message) {
      if (key) notes.lines[key] = message;
      else notes.page = message;
    }

    function reloadWith(notes) {
      if (Object.keys(notes.lines).length || notes.page) {
        try {
          w.sessionStorage.setItem(storeKey, JSON.stringify(notes));
        } catch (e) {
          // no storage in this tab: the theme's own note at the stock limit still explains the line after the reload
        }
      }
      w.location.assign(cartUrl);
    }

    // Minus, plus and Remove.
    form.addEventListener('click', function (event) {
      var link = event.target && event.target.closest ? event.target.closest('a.plus, a.minus, a.remove') : null;
      if (!link || !form.contains(link)) return;
      if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var lineMatch = /[?&]line=(\d+)/.exec(link.search);
      var quantityMatch = /[?&]quantity=(\d+)/.exec(link.search);
      if (!lineMatch || !quantityMatch) return;
      event.preventDefault();
      if (busy || leaving) return;
      setBusy(true);
      var holder = link.closest('.quantity-and-remove');
      var field = holder ? holder.querySelector('input[name="updates[]"]') : null;
      var key = field ? field.getAttribute('data-sk-key') : null;
      var target = key ? { id: key } : { line: parseInt(lineMatch[1], 10) };
      changeLine(target, parseInt(quantityMatch[1], 10)).then(function (result) {
        var notes = { lines: {}, page: '' };
        if (!result.ok) addMessage(notes, key, result.message);
        reloadWith(notes);
      }, function () {
        // The cart could not be reached: the link works as before (one change, as the theme sent it).
        w.location.href = link.href;
      });
    });

    // "Update cart", and Enter in a quantity field (the browser presses the form's first button, "Update cart").
    form.addEventListener('submit', function (event) {
      if (form.hasAttribute('data-sk-native-submit')) return;
      var submitter = event.submitter;
      var active = d.activeElement;
      var isUpdate = submitter ? submitter.name === 'update' : !!(active && (active.name === 'updates[]' || active.name === 'update'));
      if (!isUpdate) {
        // "Check out": left to the browser, but held back while a change is being sent (the page loads again a
        // moment later with the new quantities). Once it has gone ahead, the quantity controls wait for the next page.
        if (busy) {
          event.preventDefault();
          return;
        }
        w.setTimeout(function () {
          if (!event.defaultPrevented) leaving = true;
        }, 0);
        return;
      }
      event.preventDefault();
      if (busy || leaving) return;

      var fields = quantityFields();
      var jobs = [];
      var firstInvalid = null;
      for (var i = 0; i < fields.length; i++) {
        var typed = String(fields[i].value).replace(/^\s+|\s+$/g, '');
        if (typed === String(fields[i].defaultValue)) continue;
        if (!/^\d+$/.test(typed)) {
          showNote(fields[i], 'Please enter a whole number.', true);
          if (!firstInvalid) firstInvalid = fields[i];
          continue;
        }
        jobs.push({ line: i + 1, key: fields[i].getAttribute('data-sk-key'), quantity: parseInt(typed, 10) });
      }
      if (firstInvalid) {
        firstInvalid.focus();
        return;
      }

      setBusy(true);
      jobs.sort(function (a, b) {
        return b.line - a.line;
      });
      var notes = { lines: {}, page: '' };
      var answered = 0;
      var chain = Promise.resolve();
      jobs.forEach(function (job) {
        chain = chain.then(function () {
          return changeLine(job.key ? { id: job.key } : { line: job.line }, job.quantity).then(function (result) {
            answered++;
            if (!result.ok) addMessage(notes, job.key, result.message);
          });
        });
      });
      chain.then(saveCartNote).then(function () {
        reloadWith(notes);
      }, function () {
        if (answered) {
          // Some lines have changed already, so the form's quantities (matched to lines by position) may no longer
          // fit the cart: load the cart again and say so.
          notes.page = partial;
          reloadWith(notes);
          return;
        }
        // Nothing has changed: send the form as the theme did (formnovalidate on "Update cart" lets it through the
        // terms box).
        setBusy(false);
        form.setAttribute('data-sk-native-submit', '');
        if (submitter && form.requestSubmit) {
          form.requestSubmit(submitter);
        } else {
          var flag = d.createElement('input');
          flag.type = 'hidden';
          flag.name = 'update';
          flag.value = '1';
          flag.setAttribute('data-sk-update-flag', '');
          form.appendChild(flag);
          form.submit();
        }
      });
    });
  }

  /* ---- J. "Added to cart" window: Continue Shopping ------------------------------------------------------ */
  // Review fixes (13 Oct 2026). The theme's script (assets/theme.js) writes this link with the live site's full
  // address, https://www.saiidkobeisy.com/collections/shop, so on any other address of the store (the theme preview,
  // the SK SECOND SANDBOX preview, ar.saiidkobeisy.com) it left for the live English site. Before the link is
  // followed, opened in a new tab, hovered, focused or touched, it is pointed at the same page on the address being
  // viewed. Links to other sites, and the link on the live site itself, are left as they are.
  function keepContinueShoppingHere() {
    function localise(event) {
      var link = event.target && event.target.closest ? event.target.closest('a.continueshopping') : null;
      if (!link) return;
      var parts = /^https?:\/\/([^\/?#]+)([^?#]*)(\?[^#]*)?(#.*)?$/i.exec(link.getAttribute('href') || '');
      if (!parts) return;
      var host = parts[1].toLowerCase();
      if (host === w.location.host.toLowerCase() || !/(^|\.)saiidkobeisy\.com$/.test(host)) return;
      link.setAttribute('href', (parts[2] || '/') + (parts[3] || '') + (parts[4] || ''));
    }
    ['mouseover', 'mousedown', 'focusin', 'touchstart', 'contextmenu', 'click'].forEach(function (type) {
      d.addEventListener(type, localise, type === 'touchstart' ? { capture: true, passive: true } : true);
    });
  }

  /* ---- K. Trunk Shows: "Book Your Appointment" -------------------------------------------------------------- */
  // Review fixes, second pass (13 Oct 2026). On Trunk Shows the page's own script (sections/trunkshows-register-form
  // .liquid) opens the registration window, with the show chosen, on a click anywhere in a show's column. The shows'
  // "Book Your Appointment" has no link in the page's content and was printed as a link to an empty address, so the
  // click opened the window and then reloaded the page. sections/text-columns-with-images.liquid now prints a label
  // without a link as a plain button, hidden; it is shown here only where that window and the conditions of its
  // script are on the page, so a button without a link never appears where it would do nothing.
  // The window sits in a block that the theme fades in once it has been scrolled into view (on screens 768px and
  // wider). That block has no height, so the fade-in can be skipped (seen on 13 Oct with the page opened further
  // down): the window then opened unseen, under the shows, over the whole page. The block is kept shown here.
  // For the keyboard: after a show's button opens the window, the focus moves into it; Escape closes it (as its x
  // does) and the focus goes back to the button.
  function initShowButtons() {
    var rows = d.querySelectorAll('[data-sk-popup-button]');
    var popup = d.querySelector('.register-popup-container');
    if (!rows.length || !w.trunkShowTitles || !popup || !d.querySelector('.popup-close')) return;

    for (var host = popup.parentNode; host && host !== d.body; host = host.parentNode) {
      if (host.hasAttribute && host.hasAttribute('data-cc-animate')) host.classList.add('sk-popup-host');
    }

    var modal = popup.querySelector('.trunkshow-modal') || popup;
    var opener = null;
    function openedBy(event) {
      opener = event.currentTarget;
      // after the page's own script has opened the window and chosen the show (it waits 100 ms)
      w.setTimeout(function () {
        if (!popup.classList.contains('show')) return;
        if (!modal.hasAttribute('tabindex')) modal.setAttribute('tabindex', '-1');
        modal.focus();
      }, 150);
    }
    for (var i = 0; i < rows.length; i++) {
      if (!rows[i].closest || !rows[i].closest('.flexible-layout--variable-columns .text-column')) continue;
      rows[i].hidden = false;
      var button = rows[i].querySelector('button');
      if (button) button.addEventListener('click', openedBy);
    }
    d.addEventListener('keydown', function (event) {
      if ((event.key !== 'Escape' && event.key !== 'Esc') || !popup.classList.contains('show')) return;
      popup.classList.remove('show');
      d.body.classList.remove('body-overflow-hidden');
      if (opener && opener.focus) opener.focus();
      opener = null;
    });
  }

  ready(function () {
    dockWhatsApp();
    watchCurrency();
    followHeaderTone();
    initLanguages();
    initFilterPanel();
    watchFilterResults();
    initFilterBarTone();
    initProductPage();
    initCartQuantities();
    keepContinueShoppingHere();
    initShowButtons();
  });
})();
